import React, { Component } from 'react';
import './index.scss';
import Timeline from '../../parts/Timeline/index';
import DataHero2 from '../../json/dataHero2.json';
import DataTimeline from '../../json/timeline.json';
import HeroWorkshop from './HeroWorkshop';

class Workshop extends Component{
    render() {
        return (
            <div>
                <HeroWorkshop data={DataHero2.workshop} isLogin = {this.props.isLogIn}/>

                <div className="downArrow">&#8675;</div>
                    
                <h2 className="my-5">Timeline</h2>
                <Timeline data={DataTimeline.workshop}/> 

                <div className="ketentuan-peserta pb-5 mb-5 pr-md-1 pr-4">
                    <h4 className="ml-4">REQUIREMENT</h4>
                    <ol>
                        <li>Participants must be an active full-time undergraduate student from any major</li>
                        <li>Participants must have basic programming knowledge</li>
                        <li>Participants must have basic skill in python programming</li>
                        <li>Each Participant has AWS Educate account which participants can register on <a href="https://aws.amazon.com/education/awseducate" target="_blank" className="green"><b>aws.amazon.com/education/awseducate</b></a></li>
                        <li>Each participant must be register on <b>impulseitb.com</b></li>
                        <li>Participants must upload a video about motivations / reasons for joining Impulse Workshop and upload them on verification</li>
                        <li>Participant must share poster of impulse workshop on <a href="https://bit.ly/ImpulseWorkshop" target="_blank" className="green"><b>bit.ly/ImpulseWorkshop</b></a> to Instagram story or minimum one social media group that consist of university student</li>
                    </ol>

                    <h4 className="ml-4 mt-5">REWARD</h4>
                    <ol>
                        <li>Acquire a chance for an exclusive internship from one of our partners</li>
                        <li>Best 30 Participants Get Exclusive E-Certificates from Amazon Web Service</li>
                        <li>All participants get E-Certificates from IMPULSE ITB</li>
                        <li>Group project regarding workshop's material</li>
                        <li>Get hands on experience from some impressive experts</li>
                        <li>Workshop training will be guided by mentor from Amazon Web Services;</li>
                    </ol>
                    
                    <h5 className="ml-4 mt-5 green">Register Your Team!</h5>
                        <p className="ml-4 mb-0"><b>Free Registration</b> for opening workshop and self-paced learning</p>
                        <p className="ml-4">For Main Workshop and Project Challenge there will be registration fee of <b>Rp150.000/Person</b></p>    
                    <div className="pl-4">
                        <h6 className="mt-5 mb-0">Powered by</h6>
                        <img src="/images/Pict/aws educate.png" alt="aws educate" className="w-50 d-block mx-auto"/>
                    </div>
                </div>
            </div>
        )
    }
}

export default Workshop;